import React from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';
import AccommodationImages from '../AccommodationImages/AccommodationImages';
import { AccommodationImageType } from '../AccommodationImages/types';
import {
  AccommodationDetailsBasic,
  AccommodationUploadImages,
  getAccommodationImagesAsync,
  uploadFilesToAzureAsync,
} from '../accommodationsSlice';
import { useAppDispatch } from '../../../app/hooks';

interface ImagesViewProps {
  accommodationBasicTemp: AccommodationDetailsBasic;
  accommodationDetailsBasic: AccommodationDetailsBasic;
  transferring: boolean;
  error: boolean;
  errorText: string;
  imagesList: AccommodationImageType[];
  transferImagesGrediAzureCdn: (accommodationId: string) => void;
  fixImageIndexes: () => void;
  removeImage: (imageId: string) => void;
  HandleItemReorder: (OldNumber: number, NewNumber: number) => void;
  updateImages: (imageList: AccommodationImageType[]) => void;
}
const dropzoneStyles: React.CSSProperties = {
  border: '2px solid #cccccc',
  borderRadius: '10px',
  padding: '9px',
  fontSize: '0.75rem',
  textAlign: 'center',
  cursor: 'pointer',
  backgroundColor: '#005998',
  color: '#fff',
  textTransform: 'uppercase',
};
const ImagesView: React.FC<ImagesViewProps> = ({
  accommodationBasicTemp,
  accommodationDetailsBasic,
  transferring = false,
  error = false,
  errorText = '',
  imagesList,
  transferImagesGrediAzureCdn,
  fixImageIndexes,
  removeImage,
  HandleItemReorder,
  updateImages,
}) => {
  const dispatch = useAppDispatch();
  const onDropHandler = (acceptedFiles, accommodationId) => {
    const command = {
      imagesWithFullPath: acceptedFiles,
      accommodationId,
    } as AccommodationUploadImages;

    dispatch(uploadFilesToAzureAsync(command)).then(res => {
      dispatch(getAccommodationImagesAsync(accommodationBasicTemp.id));
    });
  };
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: acceptedFiles => {
      onDropHandler(
        acceptedFiles,
        accommodationDetailsBasic.accommodationNumber,
      );
    },
    accept: {
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/png': ['.png'],
      'image/gif': ['.gif'],
    },
    multiple: true, // Allow multiple files to be selected
  });

  const safeImagesList = imagesList ?? [];

  return (
    <div className="my-24">
      <div className="d-flex flex-column flex-sm-row gap-8 gap-sm-24 justify-content-sm-end align-items-sm-center mt-16 mb-24">
        <Form.Group>
          <Form.Check
            type="checkbox"
            name="useGredi"
            disabled
            checked={!!accommodationBasicTemp.useGredi}
            label="Kuvat Gredissä"
          />
        </Form.Group>

        <Button
          variant="outline-blue"
          disabled={!accommodationBasicTemp.isAllowedToEdit}
          size="sm"
          onClick={() =>
            transferImagesGrediAzureCdn(
              accommodationDetailsBasic.accommodationNumber.toString(),
            )
          }
        >
          Siirrä kuvat Gredistä CDN:ään
        </Button>

        <Button
          variant="outline-blue"
          disabled={!accommodationBasicTemp.isAllowedToEdit}
          size="sm"
          onClick={fixImageIndexes}
        >
          Korjaa kuvien indeksit
        </Button>

        {!accommodationBasicTemp.useGredi && (
          <div {...getRootProps()} className="btn btn-sm btn-primary">
            <input {...getInputProps()} />
            <p>Lisää uusi kuva</p>
          </div>
        )}
      </div>
      {transferring && (
        <Spinner animation="border" variant="primary" role="status">
          <span className="visually-hidden">
            Ladataan kuvia Gredistä cdn:ään...
          </span>
        </Spinner>
      )}
      {!transferring && error && (
        <span style={{ color: 'red', fontSize: 'large' }}>{errorText}</span>
      )}
      {!transferring && safeImagesList.length > 0 && (
        <AccommodationImages
          EditImage={() => console.log('EditImage')}
          RemoveImage={imageId => removeImage(imageId)}
          Images={safeImagesList}
          disabled={!accommodationBasicTemp.isAllowedToEdit}
          HandleItemReorder={HandleItemReorder}
          useGredi={accommodationBasicTemp.useGredi}
          saveImageList={updateImages}
          showEdit={false}
        />
      )}
    </div>
  );
};

export default ImagesView;
